import { Schema } from 'yup';
import * as yup from 'yup';
import { TFunction } from 'react-i18next';
import { AssociationFeeRequest } from '../models/associationFeeRequest';

export function AssociationFeeRequestSchema(t: TFunction): Schema<AssociationFeeRequest> {
  return yup.object().shape({
    localAss_id: yup.number().required(),
    paymentMethod: yup.number().required(),
    ocr: yup.string().oneOf(['true', 'false']).required(),
    // Aviseringsmetod
    sameFeeForAll: yup.number().required(),
    mainAndFamily: yup
      .object({
        feeMainMember: yup.number().required(),
        feeMainMemberAutogiro: yup.number().optional(),
        feeFamilyMember: yup.number().required(),
        feeFamilyMemberAutogiro: yup.number().required(),
      })
      .optional(),
    familySteps: yup
      .array()
      .of(
        yup.object().shape({
          member: yup.string().optional(),
          fee: yup.number().required(t('association:paymentMethod.feeRequired')),
        }),
      )
      .optional(),

    oneFeeForHousehold: yup.number().required(),
    // Profiler
    feeBasedOnProfile: yup
      .array()
      .of(
        yup.object().shape({
          memberProfileItem_id: yup.number().required(),
          profileGroup: yup.string().required(),
          profile: yup.string().required(),
          fee: yup.number().required(t('association:paymentMethod.feeRequired')),
          feeAutogiro: yup.number().optional(),
        }),
      )
      .optional()
      .nullable(),
  });
}
